import React from 'react';

import Shelf from '../Shelf';
import FloatCart from '../FloatCart';
import Appbar from '../Appbar';

const App = () => (
  <React.Fragment>
    <div className='wrapper'>
      <div className="w-100">
        <Appbar />
        <main>
          <Shelf />
        </main>
      </div>
      <FloatCart />
    </div>
  </React.Fragment>
);

export default App;
